export const express = [
  "圆通速递",
  "韵达快递",
  "中通快递",
  "申通快递",
  "邮政快递包裹",
  "百世快递",
  "顺丰速运",
  "极兔速递",
  "EMS",
  "京东物流",
  "邮政标准快递",
  "德邦快递",
  "德邦",
  "优速快递",
  "宅急送",
  "圆通快运",
  "百世快运",
  "中通快运",
  "安能快运",
  "中通国际",
  "韵达快运",
  "UPS",
  "顺丰快运",
  "特急送",
  "安得物流",
  "DHL-中国件",
  "UPS-全球件",
  "跨越速运",
  "顺心捷达",
  "丹鸟",
  "Purolator",
  "九曳供应链",
  "DHL-全球件",
  "D速快递",
  "壹米滴答",
  "京广速递",
  "FedEx-国际件",
  "加运美",
  "联昊通",
  "USPS",
  "国际包裹",
  "日日顺物流",
  "递四方",
  "汇森速运",
  "EWE全球快递",
  "速腾快递",
  "同城快寄",
  "丰网速运",
  "信丰物流",
  "中远e环球",
  "Yun Express",
  "速尔快递",
  "Titan泰坦国际速递",
  "乌克兰邮政包裹",
  "行云物流",
  "宇鑫物流",
  "美快国际物流",
  "申通国际",
  "京东快运",
  "联邦快递",
  "EMS包裹",
  "速必达",
  "三态速递",
  "众邮快递",
  "EMS-国际件",
  "威时沛运货运",
  "联合快递",
  "燕文物流",
  "苏宁物流",
  "CJ物流",
  "DPD",
  "海信物流",
  "安能快递",
  "鑫正一快递",
  "Fedex-国际件-中文",
  "招金精炼",
  "天天快递",
  "平安达腾飞",
  "卓志速运",
  "天地华宇",
  "嘉里大通",
  "Xlobo贝海国际",
  "拉火速运",
  "圆通国际",
  "龙邦速递",
  "威盛快递",
  "日本（Japan Post）",
  "中铁快运",
  "UBI Australia",
  "TNT-全球件",
  "荣庆物流",
  "程光快递",
  "优邦速运",
  "顺昌国际",
  "景光物流",
  "TNT",
  "德坤物流",
  "极地快递",
  "GLS",
  "雪域易购",
  "邦泰快运",
  "黄马甲",
  "微特派",
  "澳大利亚(Australia Post)",
  "大马鹿",
  "天马迅达",
  "盛丰物流",
  "新顺丰（NSF）",
  "金岸物流",
  "无忧物流",
  "澳邮中国快运",
  "安信达",
  "转运四方",
  "DPD Germany",
  "四季安物流",
  "Austa国际速递",
  "速通物流",
  "芝麻开门",
  "安迅物流",
  "富腾达国际货运",
  "快捷速递",
  "富吉速运",
  "Superb Express",
  "盛辉物流",
  "叁虎物流",
  "龙邦物流",
  "品骏快递",
  "斑马物流",
  "迅达速递",
  "比利时（Bpost）",
  "国通快递",
  "转运中国",
  "锦程快递",
  "方舟速递",
  "华企快运",
  "澳洲飞跃物流",
  "源安达",
  "出口易",
  "新西兰（New Zealand Post）",
  "疯狂快递",
  "宏递快运",
  "泛捷国际速递",
  "新杰物流",
  "泰进物流",
  "EMS-国际件-英文",
  "递四方美国",
  "大田物流",
  "Aramex",
  "铁中快运",
  "三象速递",
  "联合速运",
  "成都立即送",
  "中速快递",
  "OCS",
  "荷兰邮政(PostNL international registered mail)",
  "海欣斯快递",
  "达发物流",
  "AAE-中国件",
  "全联速运",
  "易客满",
  "鼎润物流",
  "速达通",
  "广东邮政",
  "一正达速运",
  "中华邮政",
  "商桥物流",
  "百腾物流",
  "EFS Post（平安快递）",
  "万家物流",
  "中铁飞豹",
  "远航国际快运",
  "御风速运",
  "快捷快物流",
  "TransRush",
  "DPD UK",
  "LUCFLOW EXPRESS",
  "安达速递",
  "beiou express",
  "澳天速运",
  "宅急便",
  "百福东方",
  "优优速递",
  "速递中国",
  "贰仟家物流",
  "美通",
  "诚和通",
  "E2G速递",
  "SYNSHIP快递",
  "鸿泰物流",
  "中邮速递",
  "联合速递",
  "澳德物流",
  "MoreLink",
  "亚洲顺物流",
  "佐川急便",
  "顺丰-繁体",
  "恒路物流",
  "三真驿道",
  "COE",
  "长江国际速递",
  "合众速递(UCS）",
  "苏通快运",
  "汇通天下物流",
  "顺捷美中速递",
  "中邮物流",
  "中集冷云",
  "安鲜达",
  "万象物流",
  "安捷物流",
  "小飞侠速递",
  "黑猫宅急便",
  "家家通快递",
  "易达通快递",
  "直德邮",
  "时达通",
  "新元国际",
  "佳怡物流",
  "邮邦国际",
  "英国邮政大包EMS",
  "中外运",
  "能达速递",
  "速派快递",
  "中途速递",
  "wedepot物流",
  "山西建华",
  "星云速递",
  "三志物流",
  "TST速运通",
  "airpak expresss",
  "黑猫同城送",
  "优速通达",
  "中环快递",
  "北京EMS",
  "原飞航",
  "友家速递",
  "全一快递",
  "YDH",
  "西班牙(Correos de Espa?a)",
  "Hermes",
  "荷兰邮政-中国件",
  "签收快递",
  "帮帮发",
  "城晓国际快递",
  "德国(Deutsche Post)",
  "承诺达",
  "增益速递",
  "澳捷物流",
  "海带宝",
  "汇达物流",
  "百事亨通",
  "明通国际快递",
  "加拿大(Canada Post)",
  "德国优拜物流",
  "汇峰物流",
  "CNE",
  "韩国邮政",
  "DHL-德国件（DHL Deutschland）",
  "武汉优进汇",
  "DPEX",
  "一速递",
  "E速达",
  "货拉拉物流",
  "聚盟共建",
  "Newgistics",
  "递五方云仓",
  "丰通快运",
  "顺达快递",
  "永昌物流",
  "日本郵便",
  "法国小包（colissimo）",
  "天翼快递",
  "DHL Benelux",
  "集先锋快递",
  "中翼国际物流",
  "DPD Poland",
  "佳吉快运",
  "春风物流",
  "FedEx-美国件",
  "商壹国际物流",
  "51跨境通",
  "加拿大龙行速运",
  "英超物流",
  "永邦国际物流",
  "CNPEX中邮快递",
  "联邦快递-英文",
  "皮牙子快递",
  "天天欧洲物流",
  "飞豹快递",
  "明达国际速递",
  "韵达国际",
  "Gati-中文",
  "昌宇国际",
  "飞远配送",
  "劲通快递",
  "佰麒快递",
  "CHS中环国际快递",
  "远成物流",
  "喀麦隆(CAMPOST)",
  "全峰快递",
  "西游寄",
  "银雁专送",
  "中邮电商",
  "英国大包、EMS（Parcel Force）",
  "洋口岸",
  "运通中港",
  "宇佳物流",
  "中外运速递",
  "法国(La Poste)",
  "中国香港(HongKong Post)",
  "TNT Australia",
  "上海缤纷物流",
  "迅速快递",
  "EMS物流",
  "韩国（Korea Post）",
  "亚风速递",
  "百世云配",
  "泛远国际物流",
  "GTS快递",
  "环球速运",
  "万家康物流",
  "皇家云仓",
  "运通中港快递",
  "申通新西兰",
  "大韩通运",
  "上海航瑞货运",
  "飞洋快递",
  "久久物流",
  "科捷物流",
  "广州安能聚创物流",
  "海派国际速递",
  "尚橙物流",
  "EASY EXPRESS",
  "高考通知书",
  "秦邦快运",
  "魔速达",
  "瑞典（Sweden Post）",
  "TRAKPAK",
  "比利时(Belgium Post)",
  "比利时国际(Bpost international)",
  "海红网送",
  "佳辰国际速递",
  "联运通物流",
  "速舟物流",
  "OnTrac",
  "远成快运",
  "捷祥物流",
  "中国香港环球快运",
  "佳吉快递",
  "三三国际物流",
  "创运物流",
  "CDEK",
  "传喜物流",
  "贝业物流",
  "意大利(Poste Italiane)",
  "dhl小包",
  "EMS-英文",
  "耀飞同城快递",
  "阿森迪亚",
  "澳通华人物流",
  "如家国际快递",
  "上大物流",
  "顺丰冷链",
  "智通物流",
  "龙枫国际快递",
  "深圳邮政",
  "USPSCN",
  "奔腾物流",
  "华欣物流",
  "高捷快运",
  "荷兰邮政-中文(PostNL international registered mail)",
  "全川物流",
  "UEQ快递",
  "楽道物流",
  "泰国138国际物流",
  "Toll Priority(Toll Online)",
  "飞康达",
  "开心快递",
  "佳成快递 ",
  "晟邦物流",
  "荷兰包裹(PostNL International Parcels)",
  "全速物流",
  "瑞士(Swiss Post)",
  "世华通物流",
  "优海国际速递",
  "宜送物流",
  "明大快递",
  "CCES/国通快递",
  "中国香港(HongKong Post)英文",
  "红远物流",
  "南方传媒物流",
  "秦远物流",
  "泰实货运",
  "易达通",
  "7号速递",
  "飞力士物流",
  "雅澳物流",
  "运通速运",
  "C&C国际速递",
  "浩博物流",
  "泰国（Thailand Thai Post）",
  "欧亚专线",
  "颿达国际快递",
  "瀚朝物流",
  "赛澳递",
  "远盾物流",
  "黑猫速运",
  "捷安达",
  "无限配",
  "宇捷通",
  "远为快递",
  "BHT",
  "创一快递",
  "泰国中通CTO",
  "GSM",
  "鹏远国际速递",
  "万庚国际速递",
  "玥玛速运",
  "心怡物流",
  "大洋物流",
  "奉天物流",
  "华美快递",
  "宏捷国际物流",
  "人人转运",
  "卓实快运",
  "加拿大民航快递",
  "华中快递",
  "领送送",
  "配思货运",
  "一智通",
  "安世通快递",
  "邦送物流",
  "大道物流",
  "海联快递",
  "卓烨快递",
  "陆本速递 LUBEN EXPRESS",
  "易境达国际物流",
  "韵丰物流",
  "八达通",
  "凡宇快递",
  "天天快物流",
  "汇强快递",
  "一号线",
  "小熊物流",
  "雪域快递",
  "丰程物流",
  "wish邮",
  "美国申通",
  "新速航",
  "美国云达",
  "志腾物流",
  "中天万运",
  "中联速递",
  "河北橙配",
  "澳州顺风快递",
  "冠捷物流 ",
  "云邮跨境快递",
  "捷邦物流",
  "中宏物流",
  "忠信达",
  "全球快运",
  "Asendia USA",
  "澳世速递",
  "笨鸟国际",
  "好来运",
  "腾达速递",
  "祥龙运通物流",
  "中粮鲜到家物流",
  "达方物流",
  "Toll",
  "加拿大联通快运",
  "飞邦快递",
  "顺时达物流",
  "JDIEX",
  "货运皇",
  "拉脱维亚(Latvijas Pasts)",
  "美国快递",
  "美泰物流",
  "菲律宾（Philippine Postal）",
  "叙利亚(Syrian Post)",
  "rpx",
  "闪货极速达",
  "申必达",
  "顺通快递",
  "伍圆速递",
  "西邮寄",
  "DHL HK",
  "东方汇",
  "GTT EXPRESS快递",
  "聚鼎物流",
  "民航快递",
  "丹麦(Post Denmark)",
  "全日通",
  "全之鑫物流",
  "圣安物流",
  "顺捷丰达",
  "中外运速递-中文",
  "速品快递",
  "中运全速",
  "新宁物流",
  "A2U速递",
  "亚马逊中国订单",
  "青岛安捷快递",
  "爱尔兰(An Post)",
  "锋鸟物流",
  "鑫宸物流",
  "成都东骏物流",
  "全速快递",
  "全球特快",
  "加州猫速递",
  "6LS EXPRESS",
  "LWE",
  "民邦速递",
  "明亮物流",
  "新西兰中通",
  "北极星快运",
  "五六快运",
  "西安喜来快递",
  "洋包裹",
  "一起送",
  "越丰物流",
  "中技物流",
  "ADP国际快递",
  "加拿大邮政",
  "河南次晨达",
  "日日顺智慧物联",
  "佳捷翔物流",
  "LaserShip",
  "華信物流WTO",
  "马来西亚小包（Malaysia Post(Registered)）",
  "日日顺快线",
  "全时速运",
  "林道国际快递",
  "速风快递",
  "track-parcel",
  "亚马逊中国",
  "中环转运",
  "众派速递",
  "明辉物流",
  "中远快运",
  "增速跨境 ",
  "ABF",
  "amazon-国内订单",
  "AOL澳通速递",
  "百通物流",
  "城市映急",
  "CNAIR",
  "E跨通",
  "Gati-英文",
  "globaltracktrace",
  "海外环球",
  "海星桥快递",
  "华通快运",
  "景顺物流",
  "考拉速递",
  "十方通物流",
  "TNT Italy",
  "维普恩物流",
  "一辉物流",
  "云达通",
  "众川国际",
  "泰捷达国际物流",
  "青云物流",
  "巴西(Brazil Post/Correios)",
  "城际快递",
  "中骅物流",
  "邦通国际",
  "云南诚中物流",
  "深圳德创物流",
  "东红物流",
  "e直运",
  "可可树美中速运",
  "飞快达",
  "环东物流",
  "爱拜物流",
  "jcex",
  "急先达",
  "考拉国际速递",
  "跨境直邮通",
  "林道国际快递-英文",
  "Linex",
  "美西快递",
  "俄罗斯邮政(Russian Post)",
  "赛澳递for买卖宝",
  "塞尔维亚(PE Post of Serbia)",
  "新加坡小包(Singapore Post)",
  "淘布斯国际物流",
  "TNT Post",
  "万博快递",
  "豌豆物流",
  "一邦速递",
  "银捷速递",
  "众辉达物流",
  "ZTE中兴物流",
  "德国雄鹰速递",
  "安达信",
  "澳货通",
  "奥地利(Austrian Post)",
  "宝通快递",
  "嘉荣物流",
  "City-Link",
  "哥伦比亚(4-72 La Red Postal de Colombia)",
  "德中快递",
  "龙象国际物流",
  "英国(大包,EMS)",
  "Estafeta",
  "易达国际速递",
  "易优包裹",
  "FedRoad 联邦转运",
  "飞狐快递",
  "安的快递",
  "全网物流",
  "新鹏快递",
  "GE2D跨境物流",
  "海盟速递",
  "航宇快递",
  "好又快物流",
  "环国运物流",
  "飞鹰物流",
  "宏品物流",
  "大达物流",
  "捷运达快递",
  "金大物流",
  "骏丰国际速递",
  "哈萨克斯坦(Kazpost)",
  "快服务",
  "乐递供应链",
  "卢森堡(Luxembourg Post)",
  "猛犸速递",
  "MRW",
  "OC-Post",
  "PCA Express",
  "皇家物流",
  "7E速递",
  "全际通",
  "睿和泰速运",
  "曹操到",
  "顺捷达",
  "红马甲物流",
  "TCXB国际物流",
  "万家通快递",
  "老扬州物流",
  "通和天下",
  "越南EMS(VNPost Express)",
  "西翼物流",
  "翔腾物流",
  "西游寄速递",
  "易通达",
  "YODEL",
  "邮来速递",
  "运通快运",
  "元智捷诚",
  "转瞬达集运",
  "AFL",
  "全程快递",
  "捷记方舟",
  "阿尔巴尼亚(Posta shqipatre)",
  "安家同城快运",
  "澳速物流",
  "阿鲁巴[荷兰]（Post Aruba）",
  "阿塞拜疆EMS(EMS AzerExpressPost)",
  "孟加拉国(EMS)",
  "白俄罗斯(Belpochta)",
  "彪记快递",
  "玻利维亚",
  "BRT",
  "柬埔寨(Cambodia Post)",
  "智利(Correos Chile)",
  "同舟行物流",
  "法国大包、EMS-英文(Chronopost France)",
  "长吉物流",
  "群航国际物流",
  "中澳速递",
  "中欧物流",
  "丹递56",
  "DTDC India",
  "ECMS Express",
  "易联通达",
  "南非EMS",
  "EU-EXPRESS",
  "败欧洲",
  "优莎速运",
  "凤凰快递",
  "芬兰(Itella Posti Oy)",
  "法翔速运",
  "环创物流",
  "共速达",
  "德尚国际速递",
  "GT国际快运",
  "海红for买卖宝",
  "翰丰快递",
  "合心速递",
  "华瀚快递",
  "飞豹速递",
  "河南全速通",
  "居家通",
  "驼峰国际",
  "恒宇运通",
  "印度尼西亚EMS(Pos Indonesia-EMS)",
  "驿扬国际速运",
  "牙买加（Jamaica Post）",
  "骏达快递",
  "澳速通国际速递",
  "加佳物流",
  "极光转运",
  "锦程物流",
  "晋越快递",
  "KCS",
  "嘉里大荣物流",
  "韩国邮政韩文",
  "淘韩国际快递",
  "快速递",
  "快8速运",
  "蓝镖快递",
  "林安物流",
  "Lion Parcel",
  "新易泰",
  "长风物流",
  "鲁通快运",
  "中国澳门(Macau Post)",
  "马来西亚大包、EMS（Malaysia Post(parcel,EMS)）",
  "木春货运",
  "美龙快递",
  "NandanCourier",
  "Nova Poshta",
  "诺尔国际物流",
  "OCA Argentina",
  "爱沙尼亚(Eesti Post)",
  "一号仓",
  "全球速递",
  "先锋国际快递",
  "葡萄牙（Portugal CTT）",
  "POS INDONESIA",
  "急顺通",
  "卡塔尔（Qatar Post）",
  "Quantium",
  "全通快运",
  "日日通国际",
  "S2C",
  "中加国际快递",
  "四川星程快递",
  "澳丰速递",
  "上海快通",
  "杰响物流",
  "神骏物流",
  "阳光快递",
  "中外运空运",
  "skynet",
  "斯里兰卡(Sri Lanka Post)",
  "新加坡EMS、大包(Singapore Speedpost)",
  "苏丹（Sudapost）",
  "穗佳物流",
  "速配欧翼",
  "深圳DPEX",
  "TNY物流",
  "优联吉运",
  "UPS Freight",
  "华夏国际速递",
  "越南小包(Vietnam Posts)",
  "wowexpress",
  "WTD海外通",
  "西安城联速递",
  "鑫远东速运",
  "宇航通物流",
  "亿领速运",
  "易邮速运",
  "壹品速递",
  "粤中国际货运代理（上海）有限公司",
  "珠峰速运",
  "振捷国际货运",
  "中融泰隆",
  "准实快运",
  "AAA Cooper Transportation",
  "aCommerce",
  "安达易国际速递",
  "ADSone",
  "阿富汗(Afghan Post)",
  "德方物流",
  "卡邦配送",
  "AlfaTrex",
  "Algeria Post",
  "ALLIED",
  "amazon-国际订单",
  "新干线快递",
  "Anteraja",
  "apgecommerce",
  "美国汉邦快递",
  "ARC",
  "艾瑞斯远",
  "澳达国际物流",
  "澳邦国际物流",
  "AUV国际快递",
  "澳新物流",
  "巴林(Bahrain Post)",
  "百世国际",
  "报通快递",
  "巴巴多斯(Barbados Post)",
  "BCWELT",
  "BDC快递",
  "蜜蜂速递",
  "BEE express",
  "伯利兹(Belize Postal)",
  "飛斯特",
  "不丹邮政 Bhutan Post",
  "鑫锐达",
  "远通盛源",
  "佰乐捷通",
  "BlueDart",
  "标杆物流",
  "波黑(JP BH Posta)",
  "BorderGuru",
  "堡昕德速递",
  "博茨瓦纳",
  "速方(Sufast)",
  "百千诚物流",
  "宏桥国际物流",
  "文莱(Brunei Postal)",
  "保加利亚（Bulgarian Posts）",
  "展勤快递",
  "新喀里多尼亚[法国](New Caledonia)",
  "到了港",
  "Campbell’s Express",
  "能装能送",
  "Canpar",
  "卢森堡航空",
  "广州信邦",
  "钏博物流",
  "中迅三方",
  "捷克（?eská po?ta）",
  "CEVA Logistic",
  "城铁速递",
  "成达国际速递",
  "城通物流",
  "荣通国际",
  "SQK国际速递",
  "法国大包、EMS-法文（Chronopost France）",
  "Chronopost Portugal",
  "中国香港骏辉物流",
  "citysprint",
  "CE易欧通国际速递",
  "CL日中速运",
  "CNUP 中联邮",
  "中国翼",
  "Corporate couriers logistics",
  "莫桑比克（Correios de Moçambique）",
  "乌拉圭（Correo Uruguayo）",
  "阿根廷(Correo Argentina)",
  "哥斯达黎加(Correos de Costa Rica)",
  "重庆星程快递",
  "环旅快运",
  "新时速物流",
  "塞浦路斯(Cyprus Post)",
  "达速物流",
  "DCS",
  "叮当同城",
  "Delhivery",
  "Deltec Courier",
  "澳行快递",
  "东风全球速递",
  "DHL-荷兰（DHL Netherlands）",
  "DHL-波兰（DHL Poland）",
  "dhluk",
  "云南滇驿物流",
  "递达速运",
  "叮咚澳洲转运",
  "叮咚快递",
  "Direct Link",
  "递四方澳洲",
  "吉布提",
  "天翔东捷运",
  "东瀚物流",
  "Dotzot",
  "老司机国际快递",
  "德淘邦",
  "多道供应链",
  "东方航空物流",
  "EC-Firstclass",
  "Ecom Express",
  "东西E全运",
  "厄瓜多尔(Correos del Ecuador)",
  "易达快运",
  "EFSPOST",
  "埃及（Egypt Post）",
  "艾菲尔国际速递",
  "Ekart",
  "希腊包裹（ELTA Hellenic Post）",
  "希腊EMS（ELTA Courier）",
  "阿联酋(Emirates Post)",
  "阿联酋(Emirates Post)",
  "波兰小包(Poczta Polska)",
  "波兰小包(Poczta Polska)",
  "乌克兰EMS(EMS Ukraine)",
  "乌克兰EMS-中文(EMS Ukraine)",
  "联众国际",
  "俄顺达",
  "Estes",
  "ETEEN专线",
  "埃塞俄比亚(Ethiopian postal)",
  "埃塞俄比亚(Ethiopian Post)",
  "E通速递",
  "中欧国际物流",
  "德国 EUC POST",
  "易邮国际",
  "europeanecom",
  "飛斯特運通",
  "Expeditors",
  "探路速运",
  "澳洲新干线快递",
  "易转运",
  "颿达国际快递-英文",
  "Fastway Ireland",
  "正途供应链",
  "FedEx-英国件（FedEx UK)",
  "FedEx-英国件",
  "丰羿",
  "斐济(Fiji Post)",
  "First Flight",
  "First Logistics",
  "Flash Express",
  "花瓣转运",
  "四方格",
  "FOX国际快递",
  "FQ狂派速递",
  "飞云快递系统",
  "高铁快运",
  "Gati-KWE",
  "广东诚通物流",
  "容智快运",
  "格鲁吉亚(Georgian Pos）",
  "加纳",
  "GHT物流",
  "直布罗陀[英国]( Royal Gibraltar Post)",
  "GIZTIX",
  "英脉物流",
  "时安达速递",
  "GOGOX",
  "gojavas",
  "Grab",
  "格陵兰[丹麦]（TELE Greenland A/S）",
  "潍鸿",
  "哥士传奇速递",
  "万通快递",
  "广东通路",
  "永邦快递",
  "冠庭国际物流",
  "国顺达物流",
  "国送快运",
  "圭亚那",
  "宏观国际快递",
  "光线速递",
  "贵州星程快递",
  "货六六",
  "海中转运",
  "汉邦国际速递",
  "亚美尼亚(Haypost-Armenian Postal)",
  "恒瑞物流",
  "Hi淘易快递",
  "猴急送",
  "汇捷物流",
  "互联快运",
  "共联配",
  "中强物流",
  "Holisol",
  "洪都拉斯",
  "红背心",
  "环球通达 ",
  "高铁速递",
  "克罗地亚（Hrvatska Posta）",
  "海硕高铁速递",
  "海淘物流",
  "华通务达物流",
  "华达快运",
  "华夏货运",
  "汇霖大货网",
  "匈牙利（Magyar Posta）",
  "hunter Express",
  "兰州伙伴物流",
  "户通物流",
  "鸿远物流",
  "上海昊宏国际货物",
  "华航快递",
  "冰岛(Iceland Post)",
  "泛太优达",
  "iExpress",
  "无限速递",
  "logen路坚",
  "ILYANG",
  "艾姆勒",
  "印度(India Post)",
  "INDOPAKET",
  "多米尼加（INPOSDOM – Instituto Postal Dominicano）",
  "Interlink Express",
  "Interparcel",
  "UPS i-parcel",
  "伊朗（Iran Post）",
  "以色列(Israel Post)",
  "Italy SDA",
  "IXPRESS",
  "janio",
  "嘉诚速达",
  "急递",
  "泽西岛",
  "极兔国际",
  "J&T Express",
  "捷仕",
  "佳家通货运",
  "近端",
  "冀速物流",
  "九宫物流",
  "久易快递",
  "吉祥邮（澳洲）",
  "JNE",
  "约旦(Jordan Post)",
  "骏绅物流",
  "J&T Express 泰国",
  "聚物物流",
  "聚中大",
  "Kaha Epress",
  "肯尼亚(POSTA KENYA)",
  "Kerry Express",
  "启邦国际物流",
  "柬埔寨中通",
  "番薯国际货运",
  "快达物流",
  "快淘快递",
  "四川快优达速递",
  "Kuehne+Nagel",
  "KURASI",
  "凯信达",
  "吉尔吉斯斯坦(Kyrgyz Post)",
  "跨跃国际",
  "Landmark Global",
  "蓝弧快递",
  "老挝(Lao Express) ",
  "塞内加尔",
  "拉脱维亚(Latvijas Pasts)",
  "立白宝凯物流",
  "两点之间",
  "乐达全球速递",
  "云豹国际货运",
  "莱索托(Lesotho Post)",
  "美联快递",
  "Laxship",
  "lazada",
  "联运快递",
  "黎巴嫩(Liban Post)",
  "丽狮物流",
  "立陶宛（Lietuvos pa?tas）",
  "良藤国际速递",
  "隆浪快递",
  "Loomis Express",
  "恒通快递",
  "乐天速递",
  "联通快递",
  "路邦物流",
  "吉捷国际速递",
  "论道国际物流",
  "卢森堡(Luxembourg Post)",
  "卢森堡(Luxembourg Post)",
  "马其顿(Macedonian Post)",
  "Maersk",
  "mailamericas",
  "麦力快递",
  "迈隆递运",
  "Mainfreight",
  "马尔代夫(Maldives Post)",
  "马耳他（Malta Post）",
  "芒果速递",
  "今枫国际快运",
  "毛里求斯(Mauritius Post)",
  "澳洲迈速快递",
  "美邦国际快递",
  "美达快递",
  "墨西哥（Correos de Mexico）",
  "Mexico Senda Express",
  "银河物流",
  "Mitsui OSK Lines",
  "摩尔多瓦(Posta Moldovei)",
  "蒙古国(Mongol Post) ",
  "黑山(Posta Crne Gore)",
  "摩洛哥 ( Morocco Post )",
  "Mexico Multipack",
  "中俄速通（淼信）",
  "MyHermes",
  "新亚物流",
  "纳米比亚(NamPost)",
  "Nationex",
  "红马速递",
  "荷兰速递(Nederland Post)",
  "尼尔快递",
  "尼泊尔（Nepal Postal Services）",
  "Network Courier",
  "尼日利亚(Nigerian Postal)",
  "ninja xpress",
  "Nippon Express",
  "牛仔速运",
  "NLE",
  "亚欧专线",
  "华赫物流",
  "偌亚奥国际快递",
  "NYK Line",
  "﻿OCS ANA Group",
  "阿曼(Oman Post)",
  "昂威物流",
  "OPEK",
  "波音速递",
  "巴基斯坦(Pakistan Post)",
  "巴拿马",
  "Pandu Logistics",
  "巴拉圭(Correo Paraguayo)",
  "诚一物流",
  "Park N Pracel",
  "paxel",
  "paxelen",
  "普畅物流",
  "派尔快递",
  "陪行物流",
  "鹏程快递",
  "秘鲁(SERPOST)",
  "Parcel Freight Logistics",
  "pickupp",
  "品速心达快递",
  "品信快递",
  "龙行天下",
  "葡萄牙（Portugal CTT）",
  "Portugal Seur",
  "坦桑尼亚（Tanzania Posts Corporation）",
  "PostElbe",
  "PostNord(Posten AB)",
  "挪威（Posten Norge）",
  "巴布亚新几内亚(PNG Post)",
  "PT Prima Multi Cipta",
  "土耳其",
  "ANTS EXPRESS",
  "千里速递",
  "启辰国际速递",
  "秦岭智能速运",
  "千顺快递",
  "全速通",
  "全信通快递",
  "Qxpress",
  "Red Express",
  "日昱物流",
  "罗马尼亚（Posta Romanian）",
  "皇家国际速运",
  "瑞典（Sweden Post）",
  "润百特货",
  "卢旺达(Rwanda i-posita)",
  "Safexpress",
  "Correo El Salvador",
  "萨摩亚(Samoa Post)",
  "三盛快递",
  "SAP EXPRESS",
  "沙特阿拉伯(Saudi Post)",
  "SCG",
  "速佳达快运",
  "速呈",
  "首达速运",
  "Selektvracht",
  "森鼎国际物流",
  "Sendle",
  "International Seur",
  "圣飞捷快递",
  "Shadowfax",
  "衫达快运",
  "上海无疆for买卖宝",
  "尚途国际货运",
  "捎客物流",
  "商海德物流",
  "盛通快递",
  "神马快递",
  "王牌快递",
  "苏豪快递",
  "世运快递",
  "SHL畅灵国际物流",
  "shreeanjanicourier",
  "顺邦国际物流",
  "顺士达速运",
  "SiCepat Ekspres",
  "四海快递",
  "四海捷运",
  "Siodemka",
  "易普递",
  "SkyNet Malaysia",
  "skynetworldwide",
  "荷兰Sky Post",
  "斯洛伐克(Slovenská Posta)",
  "斯洛文尼亚(Slovenia Post)",
  "嗖一下同城快递",
  "所罗门群岛",
  "布基纳法索",
  "南非（South African Post Office）",
  "行必达",
  "Spoton",
  "速速达",
  "首通快运",
  "星速递",
  "星运快递",
  "圣卢西亚",
  "智德物流",
  "速豹",
  "速呈宅配",
  "特急便物流",
  "郑州速捷",
  "圣文森特和格林纳丁斯",
  "斯威士兰",
  "瑞士邮政",
  "顺友物流",
  "天美快递",
  "坦桑尼亚(Tanzania Posts)",
  "淘特物流快递",
  "TCI XPS",
  "TD Cargo",
  "The BlueBhell Couriers",
  "加拿大雷霆快递",
  "天翔快递",
  "天纵物流",
  "TiKi",
  "Shree Tirupati",
  "天联快运",
  "株式会社T.M.G",
  "TNT UK",
  "通达兴物流",
  "顶世国际物流",
  "The Professional Couriers",
  "Trans Kargo",
  "突尼斯EMS(Rapid-Poste)",
  "海龟国际快递",
  "天翼物流",
  "UEX国际物流",
  "欧洲UEX",
  "乌干达(Posta Uganda)",
  "邮鸽速运",
  "乌克兰小包、大包(UkrPoshta)",
  "乌克兰小包、大包(UkrPost)",
  "Uni Express",
  "UParcel",
  "UPS Mail Innovations",
  "UTAO优到",
  "乌兹别克斯坦(Post of Uzbekistan)",
  "瓦努阿图(Vanuatu Post)",
  "越中国际物流",
  "鹰运国际速递",
  "Wahana",
  "宁夏万家通",
  "万达美",
  "文捷航空",
  "威速递",
  "香港伟豪国际物流",
  "万邑通",
  "凡仕特物流",
  "星空国际",
  "渥途国际速运",
  "沃埃家",
  "臣邦同城",
  "万运国际快递",
  "微转运",
  "国晶物流",
  "蓝天物流",
  "鑫宏福物流",
  "湘达物流",
  "新元快递",
  "XpressBees",
  "鑫世锐达",
  "鑫通宝物流",
  "YCG物流",
  "易达丰国际速递",
  "也门(Yemen Post)",
  "驿递汇速递",
  "艺凡快递",
  "易航物流",
  "yikonn",
  "易欧洲国际物流",
  "一柒国际物流",
  "亿顺航",
  "宜送",
  "益加盛快递",
  "优胜国际速递",
  "西安运逸快递",
  "一运全成物流",
  "赞比亚",
  "智谷特货",
]